// src/hooks/usePopulateServiceVisitData

import { useEffect } from 'react'

/**
 * Populates providerServiceVisitTypes and providerServiceVisitNames.
 *
 * @param {Array} serviceTypes - The array of service types.
 * @param {Object} provider - The provider object from Redux.
 * @param {Object} visitTypes - The visitTypes state.
 * @param {Function} setProviderServiceVisitTypes - Setter for providerServiceVisitTypes.
 * @param {Function} setProviderServiceVisitNames - Setter for providerServiceVisitNames.
 */
export const usePopulateServiceVisitData = (
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  serviceTypes,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  provider,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  visitTypes,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setProviderServiceVisitTypes,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  setProviderServiceVisitNames,
) => {
  useEffect(() => {
    if (
      Array.isArray(serviceTypes) &&
      serviceTypes.length > 0 &&
      provider?.Licenses &&
      Array.isArray(provider.Licenses)
    ) {
      // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
      let list = []
      const serviceVisitNamesSet = new Set()
      // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
      const serviceVisitTypes = []

      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      provider.Licenses.forEach((license) => {
        if (license.VisitTypes && Array.isArray(license.VisitTypes)) {
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          const newVisitObjects = license.VisitTypes.map((visitObject) => ({
            ...visitObject,
            StateCode: license.StateCode,
          }))
          // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
          list = [...list, ...newVisitObjects]
        } else {
          console.warn('License is missing VisitTypes or VisitTypes is not an array:', license)
        }
      })

      // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
      list.forEach((visit) => {
        if (visit.VisitTypeId) {
          const serviceType = visitTypes[visit.VisitTypeId]
          if (serviceType) {
            const foundService = { ...serviceType, StateCode: visit.StateCode }
            // Async ("Reviewed") visit types can only be created by patients meeting their
            // eligibility criteria; exclude them from the admin create-visit dropdown.
            if (foundService.IsAsynchronous) {
              return
            }
            if (foundService.ServiceVisitName) {
              serviceVisitNamesSet.add(foundService.ServiceVisitName)
            } else {
              console.warn('ServiceVisitName is undefined for:', foundService)
            }
            serviceVisitTypes.push({ ...foundService, VisitTypes: visit })
          } else {
            console.warn(`ServiceType with VisitTypeId ${visit.VisitTypeId} is undefined`, visit)
          }
        } else {
          console.warn('Visit is missing VisitTypeId:', visit)
        }
      })

      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      const sortedServiceVisitNames = Array.from(serviceVisitNamesSet).sort((a, b) => a.localeCompare(b))

      // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
      setProviderServiceVisitTypes(serviceVisitTypes)
      setProviderServiceVisitNames(sortedServiceVisitNames)
    } else {
      console.warn('Insufficient data to populate service visit data:', { serviceTypes, provider })
      setProviderServiceVisitTypes([])
      setProviderServiceVisitNames([])
    }
  }, [serviceTypes, provider, visitTypes, setProviderServiceVisitTypes, setProviderServiceVisitNames])
}
